<div class="app-shell">
  <app-header />
  <main class="main-content">
    <router-outlet />
  </main>
  <app-footer />
</div>
